/* tslint:disable */
/* eslint-disable */
/**
 * Brokers API
 * API for managing brokers
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateBrokerCommand,
  GetBrokerListResponse,
  GetBrokerResponse,
  GetBrokers404Response,
  GetGenericListCommandDto,
  GetLeadBrokerListResponse,
  OperationResponse,
  UpdateBrokerCommand,
} from '../models/index';
import {
    CreateBrokerCommandFromJSON,
    CreateBrokerCommandToJSON,
    GetBrokerListResponseFromJSON,
    GetBrokerListResponseToJSON,
    GetBrokerResponseFromJSON,
    GetBrokerResponseToJSON,
    GetBrokers404ResponseFromJSON,
    GetBrokers404ResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
    GetLeadBrokerListResponseFromJSON,
    GetLeadBrokerListResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    UpdateBrokerCommandFromJSON,
    UpdateBrokerCommandToJSON,
} from '../models/index';

export interface CreateBrokerRequest {
    createBrokerCommand: CreateBrokerCommand;
}

export interface GetBrokerRequest {
    courtierId: string;
}

export interface GetBrokersRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetBrokersPlateformeRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface UpdateBrokerRequest {
    courtierId: string;
    updateBrokerCommand: UpdateBrokerCommand;
}

/**
 * 
 */
export class BrokersApi extends runtime.BaseAPI {

    /**
     * Create brokers
     */
    async createBrokerRaw(requestParameters: CreateBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createBrokerCommand'] == null) {
            throw new runtime.RequiredError(
                'createBrokerCommand',
                'Required parameter "createBrokerCommand" was null or undefined when calling createBroker().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/courtiers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBrokerCommandToJSON(requestParameters['createBrokerCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create brokers
     */
    async createBroker(requestParameters: CreateBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createBrokerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lit le cabinet et son compte de référence au format de la commande de mise à jour, pour préremplir le formulaire d\'édition. Permission Courtiers.Create (comme la mise à jour). 
     * Get a broker
     */
    async getBrokerRaw(requestParameters: GetBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBrokerResponse>> {
        if (requestParameters['courtierId'] == null) {
            throw new runtime.RequiredError(
                'courtierId',
                'Required parameter "courtierId" was null or undefined when calling getBroker().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/courtiers/{courtierId}`.replace(`{${"courtierId"}}`, encodeURIComponent(String(requestParameters['courtierId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBrokerResponseFromJSON(jsonValue));
    }

    /**
     * Lit le cabinet et son compte de référence au format de la commande de mise à jour, pour préremplir le formulaire d\'édition. Permission Courtiers.Create (comme la mise à jour). 
     * Get a broker
     */
    async getBroker(requestParameters: GetBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBrokerResponse> {
        const response = await this.getBrokerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get brokers
     */
    async getBrokersRaw(requestParameters: GetBrokersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBrokerListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getBrokers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/courtiers/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBrokerListResponseFromJSON(jsonValue));
    }

    /**
     * Get brokers
     */
    async getBrokers(requestParameters: GetBrokersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBrokerListResponse> {
        const response = await this.getBrokersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get brokers from plateforme
     */
    async getBrokersPlateformeRaw(requestParameters: GetBrokersPlateformeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeadBrokerListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getBrokersPlateforme().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/courtiers/plateforme`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeadBrokerListResponseFromJSON(jsonValue));
    }

    /**
     * Get brokers from plateforme
     */
    async getBrokersPlateforme(requestParameters: GetBrokersPlateformeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeadBrokerListResponse> {
        const response = await this.getBrokersPlateformeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Met à jour le cabinet et son compte de référence. Permission Courtiers.Create. Les échecs métier (e-mail, identifiant ou SIRET déjà utilisés) reviennent en HTTP 200 avec isSuccess à false et errorMessage. 
     * Update a broker
     */
    async updateBrokerRaw(requestParameters: UpdateBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['courtierId'] == null) {
            throw new runtime.RequiredError(
                'courtierId',
                'Required parameter "courtierId" was null or undefined when calling updateBroker().'
            );
        }

        if (requestParameters['updateBrokerCommand'] == null) {
            throw new runtime.RequiredError(
                'updateBrokerCommand',
                'Required parameter "updateBrokerCommand" was null or undefined when calling updateBroker().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/courtiers/{courtierId}`.replace(`{${"courtierId"}}`, encodeURIComponent(String(requestParameters['courtierId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBrokerCommandToJSON(requestParameters['updateBrokerCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Met à jour le cabinet et son compte de référence. Permission Courtiers.Create. Les échecs métier (e-mail, identifiant ou SIRET déjà utilisés) reviennent en HTTP 200 avec isSuccess à false et errorMessage. 
     * Update a broker
     */
    async updateBroker(requestParameters: UpdateBrokerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateBrokerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
